import React from "react";
import LegacyButton from "../../components/Atomos/Buttons/LegacyButton";

interface RecipientListCreatedModalProps {
  isOpen: boolean;
  listName: string;
  onContinue: () => void;
}

export default function RecipientListCreatedModal({
  isOpen,
  listName,
  onContinue,
}: RecipientListCreatedModalProps): React.ReactElement | null {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[1000] overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-80" />

      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative bg-white rounded-lg shadow-xl max-w-lg w-full p-6"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="text-xl font-decimal font-medium text-Default mb-4">
            Recipient List Created
          </h2>

          <p className="text-gray-font mb-6">
            The "{listName}" list has been created.
          </p>

          <div className="flex justify-end">
            <LegacyButton
              text="CONTINUE"
              style="filled"
              color="accent"
              content="text"
              size="small"
              onClick={onContinue}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
